"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuButtonWidget = exports.validateMenuButtonProps = void 0;
var tslib_1 = require("tslib");
var TableauUI = tslib_1.__importStar(require("@tableau/tableau-ui"));
var React = tslib_1.__importStar(require("react"));
var Declarative_1 = require("../../utils/Declarative");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
function validateMenuButtonProps(menuButtonProps) {
    if (!(menuButtonProps.children || menuButtonProps['aria-label'] || menuButtonProps['aria-labelledby'])) {
        throw new Error('At least one of `children`, `aria-label` or `aria-labelledby` must be set on `menuButton` props.');
    }
}
exports.validateMenuButtonProps = validateMenuButtonProps;
/**
 * A button with an arrow indicating the availability of a popup menu, along with WAI-ARIA attributes
 * as specified at https://www.w3.org/TR/wai-aria-practices-1.1/#menubutton.
 *
 * `children`, `aria-label` or `aria-labelledby` must be set on its props.
 *
 * The display of e.g. a dropdown menu is intentionally left to the code consuming the widget.
 */
exports.MenuButtonWidget = React.forwardRef(function (props, ref) {
    var isOpen = props.isOpen, testId = props.testId, buttonProps = tslib_1.__rest(props, ["isOpen", "testId"]);
    // we want to do this but there are a few existing usages that will break at runtime, which is bad for customers. we'll come back to it.
    // don't forget to turn the test back on too
    // validateMenuButtonProps(buttonProps);
    return (React.createElement(TableauUI.Button, tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, buttonProps, { "aria-controls": isOpen ? buttonProps['aria-controls'] : undefined, "aria-expanded": isOpen, "data-tb-test-id": Declarative_1.makeTestId(testId, 'MenuButton'), onKeyDown: function (e) {
            if (e.key === 'ArrowDown' && props.onClick) {
                e.preventDefault();
                props.onClick(e);
            }
            if (props.onKeyDown) {
                props.onKeyDown(e);
            }
        }, ref: ref })));
});
exports.MenuButtonWidget.displayName = 'MenuButtonWidget';
exports.MenuButtonWidget.defaultProps = { 'aria-haspopup': 'menu', density: 'high', kind: 'outline' };
//# sourceMappingURL=MenuButtonWidget.js.map